
const mockServerValidations = (validations) => ({
  response: {data: {error: {validations}}},
});

export default {
  mockServerValidations,
};
